/* WARA 21 · Catálogo — carrito lateral y envío del pedido por WhatsApp (con imagen) */
(function(){
  'use strict';
  var W = window.WARA || {};
  var $ = function(s, c){ return (c || document).querySelector(s); };
  var $$ = function(s, c){ return [].slice.call((c || document).querySelectorAll(s)); };
  var drawer = $('[data-cart]');
  if (!drawer) return;
  var list = $('[data-cart-items]', drawer), subEl = $('[data-cart-subtotal]', drawer), noteEl = $('[data-cart-note]', drawer);
  var noteDefault = noteEl ? noteEl.innerHTML : '';
  var state = null, imgCache = { key: '', blob: null, p: null };
  var JSONH = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function track(ev, data){ try { if (W.track) W.track(ev, data || {}); } catch (e) {} }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents){
    var n = (cents || 0) / 100, f = String(W.moneyFormat || 'S/. {{amount}}').replace(/<[^>]*>/g, '');
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, k){
      if (k === 'amount_no_decimals') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
      return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    });
  }
  function opts(it){ return (it.options_with_values || []).filter(function(o){ return o.name !== 'Title' && o.value !== 'Default Title'; }); }
  function imgUrl(it, w){
    var u = it.image || (it.featured_image && it.featured_image.url) || '';
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function pUrl(it){ return it.url + (it.url.indexOf('?') > -1 ? '&' : '?') + 'view=catalogo'; }

  /* ---------- Render ---------- */
  function render(c){
    state = c;
    $$('[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; el.hidden = !c.item_count; });
    drawer.classList.toggle('is-empty', !c.item_count);
    var n = $('[data-cart-n]', drawer); if (n) n.textContent = c.item_count;
    list.innerHTML = c.items.map(function(it, i){
      var o = opts(it).map(function(x){ return esc(x.name) + ': <b>' + esc(x.value) + '</b>'; }).join(' · ');
      var im = imgUrl(it, 240);
      return '<li class="ci" data-line="' + (i + 1) + '">' +
        '<a class="ci__img" href="' + esc(pUrl(it)) + '">' + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="ci__body">' +
          '<a class="ci__t" href="' + esc(pUrl(it)) + '">' + esc(it.product_title) + '</a>' +
          (o ? '<p class="ci__o">' + o + '</p>' : '') +
          '<div class="ci__row">' +
            '<div class="qty"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Agregar uno">+</button></div>' +
            '<span class="ci__p">' + esc(money(it.final_line_price)) + '</span>' +
          '</div>' +
          '<button type="button" class="ci__rm" data-qty="0">Eliminar</button>' +
        '</div></li>';
    }).join('');
    if (subEl) subEl.textContent = money(c.total_price);
    if (noteEl) { noteEl.innerHTML = noteDefault; noteEl.classList.remove('is-alert'); }
    if (c.item_count) prebuild();
    return c;
  }
  function fetchCart(){ return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function(r){ return r.json(); }).then(render); }
  function change(line, q){
    drawer.classList.add('is-busy');
    return fetch('/cart/change.js', { method: 'POST', headers: JSONH, credentials: 'same-origin', body: JSON.stringify({ line: line, quantity: q }) })
      .then(function(r){ return r.json(); }).then(render)
      .catch(function(){ return fetchCart(); })
      .then(function(){ drawer.classList.remove('is-busy'); });
  }

  /* ---------- Abrir / cerrar ---------- */
  function open(){
    drawer.hidden = false;
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ drawer.classList.add('is-open'); }); });
    document.body.classList.add('cart-open');
    track('ver_carrito', { items: state ? state.item_count : 0 });
  }
  function close(){
    drawer.classList.remove('is-open');
    document.body.classList.remove('cart-open');
    setTimeout(function(){ if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 360);
  }
  document.addEventListener('click', function(e){
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); fetchCart(); open(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-qty]');
    if (q && drawer.contains(q)) { var li = q.closest('[data-line]'); change(+li.dataset.line, Math.max(0, +q.dataset.qty)); }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  window.addEventListener('pageshow', function(e){ if (e.persisted) fetchCart(); });

  /* ---------- Agregar al carrito (ficha de producto) ---------- */
  var pdp = $('[data-pdp]');
  if (pdp) {
    var pj = {}; try { pj = JSON.parse($('[data-product-json]', pdp).textContent); } catch (e) {}
    var hint = $('[data-hint]', pdp);
    $$('[data-add-cart]', pdp).forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var sel = {}, miss = [];
        $$('.opt', pdp).forEach(function(fs){ var c = $('input:checked', fs); if (c) sel[fs.dataset.opt] = c.value; else miss.push(fs); });
        if (miss.length) {
          miss.forEach(function(fs){ fs.classList.add('is-missing'); });
          if (hint) hint.textContent = 'Elige ' + miss.map(function(fs){ return fs.dataset.kind === 'size' ? 'tu talla' : fs.dataset.kind === 'color' ? 'un color' : 'una opción'; }).join(' y ') + ' para agregar al carrito.';
          miss[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        var vs = pj.variants || [];
        var v = vs.filter(function(x){ return Object.keys(sel).every(function(k){ return x.o[k] === sel[k]; }); })[0];
        if (!v || !v.id) { if (hint) hint.textContent = 'Esa combinación no está disponible.'; return; }
        if (!v.a) { if (hint) hint.textContent = 'Esa talla/color está agotado. Consúltanos por WhatsApp.'; return; }
        if (hint) hint.textContent = '';
        btn.classList.add('is-busy');
        fetch('/cart/add.js', { method: 'POST', headers: JSONH, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
          .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
          .then(fetchCart)
          .then(function(){
            open();
            $$('.hdr__cart').forEach(function(b){ b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
            track('agregar_carrito', { product: pj.title, id: pj.id, variant: v.id });
          })
          .catch(function(err){ if (hint) hint.textContent = (err && (err.description || err.message)) || 'No se pudo agregar. Intenta de nuevo.'; })
          .then(function(){ btn.classList.remove('is-busy'); });
      });
    });
  }

  /* ---------- Texto del pedido ---------- */
  function orderLink(c){
    return location.origin + '/pages/pedido?i=' + c.items.map(function(it){ return it.handle + '.' + it.variant_id + '.' + it.quantity; }).join('~');
  }
  function orderText(c){
    var L = ['Hola Wara 21 👋', 'Quiero consultar disponibilidad de mi pedido:', ''];
    c.items.forEach(function(it, i){
      var o = opts(it).map(function(x){ return x.name + ': ' + x.value; }).join(' · ');
      L.push((i + 1) + ') ' + it.product_title + (o ? '\n   ' + o : '') + '\n   Cantidad: ' + it.quantity + ' · ' + money(it.final_line_price));
    });
    L.push('', 'Total: ' + money(c.total_price), '', '📸 Ver mi pedido con fotos:', orderLink(c), '', '¿Me confirman si está disponible? 🙏');
    return L.join('\n');
  }

  /* ---------- Imagen del pedido (fotos + talla + color) ---------- */
  function loadImg(src){
    return new Promise(function(res){
      if (!src) return res(null);
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function(){ res(im); }; im.onerror = function(){ res(null); };
      im.src = src;
    });
  }
  function cover(x, im, dx, dy, dw, dh){
    var r = Math.max(dw / im.width, dh / im.height), sw = dw / r, sh = dh / r;
    var sx = (im.width - sw) / 2, sy = (im.height - sh) * 0.18;
    x.drawImage(im, sx, sy, sw, sh, dx, dy, dw, dh);
  }
  function wrap(x, text, maxW, maxLines){
    var words = String(text).split(' '), lines = [], line = '';
    words.forEach(function(w){ var t = line ? line + ' ' + w : w; if (x.measureText(t).width > maxW && line) { lines.push(line); line = w; } else line = t; });
    if (line) lines.push(line);
    if (lines.length > maxLines) { lines = lines.slice(0, maxLines); lines[maxLines - 1] = lines[maxLines - 1].replace(/\s*\S*$/, '') + '…'; }
    return lines;
  }
  function buildImage(c){
    var Wd = 1080, P = 64, headH = 250, rowH = 440, footH = 260, ph = 380, pw = 285;
    var H = headH + c.items.length * rowH + footH;
    var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    return fontsReady.then(function(){
      return Promise.all([loadImg(W.logo)].concat(c.items.map(function(it){ return loadImg(imgUrl(it, 600)); })));
    }).then(function(imgs){
      var logo = imgs[0], photos = imgs.slice(1);
      var cv = document.createElement('canvas'); cv.width = Wd; cv.height = H;
      var x = cv.getContext('2d');
      var F = 'Archivo, Arial, sans-serif', D = '"Bodoni Moda", Georgia, serif';
      var INK = '#121212', RED = '#E3202B', MUTE = '#6F6A64', LINE = '#E4DFD8', SAND = '#F3EFEA';
      x.fillStyle = '#fff'; x.fillRect(0, 0, Wd, H);
      /* encabezado */
      x.fillStyle = INK; x.fillRect(0, 0, Wd, 14);
      if (logo) { var lw = 250, lh = lw * logo.height / logo.width; x.drawImage(logo, P, 70, lw, lh); }
      else { x.fillStyle = INK; x.font = '600 44px ' + F; x.fillText('WARA 21', P, 120); }
      x.textAlign = 'right';
      x.fillStyle = INK; x.font = '500 64px ' + D; x.fillText('PEDIDO', Wd - P, 120);
      x.fillStyle = MUTE; x.font = '500 24px ' + F;
      var d = new Date();
      x.fillText(d.toLocaleDateString('es-PE', { day: '2-digit', month: 'long', year: 'numeric' }) + ' · ' + c.item_count + (c.item_count === 1 ? ' prenda' : ' prendas'), Wd - P, 165);
      x.textAlign = 'left';
      x.fillStyle = RED; x.fillRect(P, headH - 34, 64, 5);
      /* prendas */
      c.items.forEach(function(it, i){
        var y = headH + i * rowH + 10;
        x.fillStyle = SAND; x.fillRect(P, y, pw, ph);
        if (photos[i]) cover(x, photos[i], P, y, pw, ph);
        var tx = P + pw + 48, tw = Wd - tx - P, ty = y + 10;
        x.fillStyle = RED; x.font = '600 26px ' + F; x.fillText(String(i + 1).padStart(2, '0'), tx, ty + 24);
        x.fillStyle = INK; x.font = '600 40px ' + F;
        var tl = wrap(x, it.product_title, tw, 2);
        tl.forEach(function(l, k){ x.fillText(l, tx, ty + 84 + k * 50); });
        var oy = ty + 84 + tl.length * 50 + 22;
        opts(it).concat([{ name: 'Cantidad', value: String(it.quantity) }]).forEach(function(o, k){
          x.fillStyle = MUTE; x.font = '500 30px ' + F; var lab = o.name + ':  ';
          x.fillText(lab, tx, oy + k * 46);
          x.fillStyle = INK; x.font = '600 30px ' + F; x.fillText(o.value, tx + x.measureText(lab).width + 4, oy + k * 46);
        });
        x.fillStyle = INK; x.font = '600 38px ' + F; x.fillText(money(it.final_line_price), tx, y + ph - 6);
        if (i < c.items.length - 1) { x.fillStyle = LINE; x.fillRect(P, y + rowH - 30, Wd - 2 * P, 2); }
      });
      /* total */
      var fy = headH + c.items.length * rowH;
      x.fillStyle = INK; x.fillRect(P, fy, Wd - 2 * P, 3);
      x.font = '600 28px ' + F; x.fillStyle = MUTE; x.fillText('TOTAL', P, fy + 78);
      x.textAlign = 'right'; x.fillStyle = INK; x.font = '600 56px ' + F; x.fillText(money(c.total_price), Wd - P, fy + 88);
      x.textAlign = 'center'; x.fillStyle = MUTE; x.font = 'italic 400 30px ' + D;
      x.fillText(W.slogan || 'Moda & elegancia a tu medida', Wd / 2, fy + 170);
      x.font = '500 22px ' + F; x.fillText('Envíos a todo el Perú · Tienda en Gamarra', Wd / 2, fy + 210);
      x.textAlign = 'left';
      x.fillStyle = RED; x.fillRect(0, H - 14, Wd, 14);
      return new Promise(function(res){ cv.toBlob(function(b){ res(b); }, 'image/png'); });
    });
  }
  function cartKey(c){ return c.items.map(function(it){ return it.key + 'x' + it.quantity; }).join('|'); }
  function prebuild(){
    var k = cartKey(state);
    if (imgCache.key === k && (imgCache.blob || imgCache.p)) return imgCache.p;
    imgCache = { key: k, blob: null, p: null };
    imgCache.p = buildImage(state).then(function(b){ if (imgCache.key === k) imgCache.blob = b; return b; }).catch(function(){ return null; });
    return imgCache.p;
  }

  /* ---------- Enviar por WhatsApp ---------- */
  function waUrl(t){ return 'https://wa.me/' + String(W.wa || '').replace(/\D/g, '') + '?text=' + encodeURIComponent(t); }
  function openWa(t){ var u = waUrl(t), w = null; try { w = window.open(u, '_blank'); } catch (e) {} if (w) { try { w.opener = null; } catch (e) {} } else location.href = u; }
  function note(html, alert){ if (!noteEl) return; noteEl.innerHTML = html; noteEl.classList.toggle('is-alert', !!alert); }
  function withTimeout(p, ms){ return Promise.race([p, new Promise(function(res){ setTimeout(function(){ res(false); }, ms); })]); }
  /* Copia la imagen del pedido al portapapeles para pegarla en el chat */
  function copyImage(blobP){
    if (!(navigator.clipboard && navigator.clipboard.write && window.ClipboardItem)) return Promise.resolve(false);
    function writeBlob(b){ return navigator.clipboard.write([new ClipboardItem({ 'image/png': b })]).then(function(){ return true; }); }
    var first;
    try {
      first = navigator.clipboard.write([new ClipboardItem({ 'image/png': blobP.then(function(b){ if (!b) throw new Error('sin imagen'); return b; }) })]).then(function(){ return true; });
    } catch (e) { first = Promise.reject(e); }
    return first.catch(function(){ return blobP.then(function(b){ return b ? writeBlob(b) : false; }); }).catch(function(){ return false; });
  }
  var sendBtn = $('[data-cart-wa]', drawer);
  if (sendBtn) sendBtn.addEventListener('click', function(){
    if (!state || !state.item_count) return;
    var text = orderText(state);
    sendBtn.classList.add('is-busy');
    var blobP = imgCache.blob && imgCache.key === cartKey(state) ? Promise.resolve(imgCache.blob) : prebuild();
    withTimeout(copyImage(blobP), 2500).then(function(copied){
      if (copied) note('✓ <b>Imagen del pedido copiada.</b> En el chat de WhatsApp mantén presionado el cuadro de mensaje y toca <b>Pegar</b> para enviarla.');
      track('whatsapp_click', { source: 'carrito', method: copied ? 'texto+imagen' : 'texto', items: state.item_count });
      openWa(text);
    }).then(function(){ sendBtn.classList.remove('is-busy'); });
  });

  /* ---------- Página "Ver pedido con fotos" (/pages/pedido?i=...) ---------- */
  var ord = $('[data-order]');
  if (ord) {
    var q = new URLSearchParams(location.search).get('i') || '';
    var parts = q.split('~').map(function(s){ var p = s.split('.'); return { handle: p[0], vid: +p[1], qty: Math.max(1, +p[2] || 1) }; }).filter(function(p){ return p.handle && p.vid; });
    var olist = $('[data-order-list]', ord), otot = $('[data-order-total]', ord), oadd = $('[data-order-add]', ord);
    if (!parts.length) { olist.innerHTML = '<li class="empty">No encontramos productos en este pedido.</li>'; }
    else Promise.all(parts.map(function(p){
      return fetch('/products/' + encodeURIComponent(p.handle) + '.js').then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; }).then(function(prod){
        if (!prod) return null;
        var v = (prod.variants || []).filter(function(x){ return x.id === p.vid; })[0];
        if (!v) return null;
        var img = (v.featured_image && v.featured_image.src) || prod.featured_image || '';
        var o = (prod.options || []).map(function(op, i){ return { name: op.name || op, value: v.options[i] }; }).filter(function(x){ return x.name !== 'Title' && x.value !== 'Default Title'; });
        return { p: p, prod: prod, v: v, img: img, o: o };
      });
    })).then(function(rows){
      rows = rows.filter(Boolean);
      if (!rows.length) { olist.innerHTML = '<li class="empty">No encontramos productos en este pedido.</li>'; return; }
      var total = 0;
      olist.innerHTML = rows.map(function(r, i){
        var line = r.v.price * r.p.qty; total += line;
        var im = r.img ? imgUrl({ image: r.img }, 500) : '';
        var url = '/products/' + r.prod.handle + '?variant=' + r.v.id + '&view=catalogo';
        return '<li class="ci">' +
          '<a class="ci__img" href="' + esc(url) + '">' + (im ? '<img src="' + esc(im) + '" alt="' + esc(r.prod.title) + '">' : '') + '</a>' +
          '<div class="ci__body"><span class="ord__n">' + String(i + 1).padStart(2, '0') + '</span>' +
            '<a class="ci__t" href="' + esc(url) + '">' + esc(r.prod.title) + '</a>' +
            r.o.map(function(x){ return '<p class="ci__o">' + esc(x.name) + ': <b>' + esc(x.value) + '</b></p>'; }).join('') +
            '<p class="ci__o">Cantidad: <b>' + r.p.qty + '</b></p>' +
            '<span class="ci__p">' + esc(money(line)) + '</span>' +
            (r.v.available ? '' : '<span class="ord__out">Agotado</span>') +
          '</div></li>';
      }).join('');
      $('strong', otot).textContent = money(total); otot.hidden = false;
      if (oadd) {
        oadd.hidden = false;
        oadd.addEventListener('click', function(){
          oadd.classList.add('is-busy');
          fetch('/cart/add.js', { method: 'POST', headers: JSONH, credentials: 'same-origin', body: JSON.stringify({ items: rows.filter(function(r){ return r.v.available; }).map(function(r){ return { id: r.v.id, quantity: r.p.qty }; }) }) })
            .then(function(r){ return r.json(); }).then(fetchCart).then(open)
            .catch(function(){}).then(function(){ oadd.classList.remove('is-busy'); });
        });
      }
    });
  }

  fetchCart();
})();
